const key = "add-file-upload-field";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[1-9]*$/);
};

const fileField = {
	Id: -1,
	Name: "File field",
	Key: {
		Code: "FILE.SINGLE"
	},
	Section: {
		Id: 219,
		IsSection: true,
		ParentContextRootSectionId: 0,
		Name: "",
		Order: 0
	},
	Type: {
		Code: "FILE",
		IsReferentialData: false,
		IsEntity: false
	},
	Description: "Description for file field",
	Order: 80,
	Template: "SingleFile",
	MaxSize: 10485760,
	AllowedMimeTypes: "application/pdf;image/png;image/jpeg;text/plain"
};

const modify = (resp) => {
	const form = resp.data.Data;
	const firstSection = form.Sections[0];

	const newFileField = {
		...fileField,
		Section: {
			...fileField.Section,
			Id: firstSection.Id
		}
	};

	form.Fields.push(newFileField);
};

export const addFileUploadField = [key, applicable, modify];